import React, { useEffect, useState } from "react";
import {
  addCommas,
  getUTM,
  showBedAndBath,
  getArea,
  getPropertyType,
  getCookie,
  setCookie,
  setLikeProperty,
} from "../common/Common";
import Config from "config";
import classnames from "classnames/bind";
import { CompareButton } from "../Compare/Common";

const pagesLink = Config.pagesLink;
const mediaURLPrefix = Config.mediaURLPrefix;
const defaultThumbnailURL = Config.defaultThumbnailURL;

const PropertyImgComp = ({ imgUrl, altName = "pfs-image" }) => {
  return (
    <>
      <img
        src={imgUrl}
        onError={({ currentTarget }) => {
          currentTarget.onerror = null; // prevents looping
          currentTarget.src = defaultThumbnailURL;
        }}
        alt={altName}
        loading="lazy"
      />
    </>
  );
};

const ImgHoverComponent = () => {
  return (
    <div className="hover">
      <div className="inner">
        <div className="icon">
          <img
            src="/SiteCollectionDocuments/assets/theme/img/icon/npa-icon-moreimg.svg"
            alt="ดูเพิ่มเติม"
          />
        </div>
        <span className="txt">ดูเพิ่มเติม</span>
      </div>
    </div>
  );
};

const PropertyBox = (property) => {
  const [isLike, setIslike] = useState(false);
  const [showLike, setShowLike] = useState(true);

  useEffect(() => {
    // if (getCookie("Allow_Cookies") === "N") {
    //   setShowLike(false);
    //   return;
    // }
    var favProp = getCookie("favoriteProperty");
    if (favProp && favProp.split(",").includes(property.PropertyID)) {
      setIslike(true);
    }
  }, []);

  function OnLikeCheck(e) {
    // e.stopPropagation();
    e.preventDefault();
    // if (getCookie("Allow_Cookies") === "N") {
    //     setShowLike(false);
    //     return;
    // }
    setLikeProperty(property.PropertyID, !isLike);
    setIslike(!isLike);
    // var favProp = getCookie("favoriteProperty");
    // if (isLike) {
    //     if (favProp) {
    //         setCookie(
    //             "favoriteProperty",
    //             favProp
    //                 .split(",")
    //                 .filter((e) => e != property.PropertyID)
    //                 .join(","),
    //             30
    //         );
    //     }
    //     setIslike(false);
    // } else if (!isLike) {
    //     if (!favProp.split(",").includes(property.PropertyID)) {
    //         setCookie(
    //             "favoriteProperty",
    //             favProp
    //                 .split(",")
    //                 .concat(property.PropertyID)
    //                 .filter((x) => x)
    //                 .join(","),
    //             30
    //         );
    //     }
    //     setIslike(true);
    // }
  }

  function goToUrl(url) {
    window.location = url;
  }

  var {
    propertyDetailURL,
    thumbnailURL,
    location,
    propertyName,
    tag,
    PromotionPrice,
    Price,
    areaHtml,
    bedRoomHtml,
    propertyTypeHtml,
    PropertyIDFormat,
    IsPartner,
    imgPCList,
  } = prepareDataForProopertyBox(property);

  // console.log("imgPCList", imgPCList);

  return (
    <>
      <div
        className={classnames(["swiper-slide", { partner: IsPartner }])}
        key={property.PropertyID}
      >
        <div className="md-thumbnail-slide">
          <a
            className="result-img md-thumbnail-img"
            data-kbct="link_click" data-kblb="link_photo" data-kbgp="content_card" data-kbsc="relate_property" data-kbid={property.PropertyID} 
            // href={void (0)} onClick={e => goToUrl(propertyDetailURL)}
            href={propertyDetailURL}
          >
            {IsPartner && (
              <div className="npa-logo-partner">
                <img src={IsPartner} alt="Logo Partner" />
              </div>
            )}
            {/* <div className="md-thumbnail-img">
              <img
                src={thumbnailURL}
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null; // prevents looping
                  currentTarget.src = defaultThumbnailURL;
                }}
                alt={propertyName}
                loading="lazy"
              />
              <div className="multi-img">
                <i className="ic-npa ic-npa-icon-multiimage"></i>
              </div>
            </div> */}
            <div className="property-img-swiper">
              <div className="swiper-wrapper">
                <div className="swiper-slide">
                  <div className="property-img-inner">
                    {imgPCList.length == 0 && <ImgHoverComponent />}
                    {
                      <PropertyImgComp
                        imgUrl={thumbnailURL}
                        altName={propertyName}
                      />
                    }
                  </div>
                </div>
                {/* 2024 add multi img */}
                {imgPCList.length > 0 &&
                  imgPCList.map((pcUrl, index) => {
                    return (
                      <div className="swiper-slide">
                        {index == imgPCList.length - 1 && <ImgHoverComponent />}
                        <div className="property-img-inner">
                          <PropertyImgComp src={pcUrl} alt={propertyName} />
                        </div>
                      </div>
                    );
                  })}
              </div>
              {imgPCList.length > 0 && (
                <>
                  <div className="swiper-button-next" />
                  <div className="swiper-button-prev" />
                  <div className="swiper-pagination" />
                </>
              )}
            </div>
          </a>
          <div className="md-thumbnail-detail">
            <div className="wrapper-tag">
              <div className="asset-tag">
                {IsPartner && (
                  <div className="tag partner">
                    <i className="ic-npa ic-npa-icon-partnershipbadge"></i>
                    <span>ทรัพย์ผู้ขาย</span>
                  </div>
                )}
                {property.PropertyID?.slice(2, 4) === "66" && (
                  <div className="tag wait-for-sale">
                    <i className="ic-npa ic-npa-icon-propertywaitsale-badge"></i>
                    &nbsp;
                    <span>ทรัพย์ฝากขาย</span>
                  </div>
                )}
                {property.IsNew && (
                  <div className="tag new">
                    <i className="ic-npa ic-npa-icon-new-badge"></i>&nbsp;
                    <span>NEW</span>
                  </div>
                )}
                {property.IsHot && (
                  <div className="tag hot">
                    <i className="ic-npa ic-npa-icon-hot-badge"></i>&nbsp;
                    <span>HOT</span>
                  </div>
                )}
                {property.PromotionName && (
                  <div className="tag promotion">
                    <i className="ic-npa ic-npa-icon-promotion-badge"></i>&nbsp;
                    <span>Promotion</span>
                  </div>
                )}
              </div>
            </div>
            <div className="wrap-asset-title">
              <a href={propertyDetailURL}
              data-kbct="link_click" data-kblb="link_title" data-kbgp="content_card" data-kbsc="relate_property" data-kbid={property.PropertyID} >
                <h3 className="asset-title">{propertyName}</h3>
              </a>
              <div className="icon-wrapper">
                <div className="box-favorite">
                  {showLike && (
                    <button
                      type="button"
                      className={classnames([
                        "property-favorite",
                        { active: isLike },
                      ])}
                      onClick={(e) => OnLikeCheck(e)}
                    >
                      <i
                        data-kbct="click" data-kblb="favorite" data-kbgp="content_card" data-kbsc="relate_property" data-kbid={property.PropertyID}
                        className={classnames([
                          "ic-npa",
                          { "ic-npa-icon-like": !isLike },
                          { "ic-npa-icon-like-active": isLike },
                        ])}
                      ></i>
                    </button>
                  )}
                  <div className="tooltip-favorite">
                    <button type="button" className="close-tooltip" />
                    <span>
                      กรุณากดยอมรับ <br /> Cookie สำหรับ <br />{" "}
                      การเพิ่มทรัพย์ถูกใจ
                    </span>
                  </div>
                </div>
                <CompareButton {...property} />
              </div>
            </div>
            <div className="location">
              <i className="ic-npa ic-npa-icon-pin"></i>
              <p>{location}</p>
            </div>
            <div className="wrap-address">
              <p className="asset-address">{propertyTypeHtml}</p>
              <p className="asset-code">รหัส {PropertyIDFormat}</p>
            </div>
            <div className="wrap-detail">
              <div className="asset-room">{bedRoomHtml}</div>
              <div className="asset-area">{areaHtml}</div>
            </div>
            <div className="wrap-price">
              {tag}
              <div className="price">
                {PromotionPrice}
                {Price}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export const PropertyList = (props) => {
  if (!props.list) {
    return <></>;
  }
  return (
    <>
      <div className="swiper-wrapper"
      data-kbct="click" data-kblb="swap_photo" data-kbgp="content_card" data-kbsc="relate_property" data-kbid={props.PropertyID} >
        {props.list.map((property, i) => (
          <PropertyBox {...property} />
        ))}
      </div>
    </>
  );
};

export function prepareDataForProopertyBox(
  property,
  { isBedPTag = false, atBath = true } = {}
) {
  //  Link & img
  var propertyDetailURL =
    pagesLink.detail.replace("{{PropID}}", property.PropertyID) + // + '&source=' + encodeURIComponent(window.location.href)
    "?" +
    getUTM();

  var thumbnail = property.PropertyMediaes?.filter(function (media) {
    return media.MediaType === "IMAGE-THUMBNAIL";
  })[0];

  var thumbnailURL;

  if (thumbnail !== undefined) {
    thumbnailURL = mediaURLPrefix + thumbnail.MediaPath;
  } else {
    thumbnailURL = defaultThumbnailURL;
  }

  var imgPCList = property.PropertyMediaes?.filter(function (media) {
    return media.MediaType === "IMAGE-PC";
  }).map((item) => {
    return mediaURLPrefix + item.MediaPath;
  });

  // Location
  var isInBangkok =
    property.ProvinceName && property.ProvinceName.indexOf("กรุงเทพ") !== -1;
  var location = "";

  if (property.AmphurName) {
    if (isInBangkok) {
      location +=
        property.AmphurName.indexOf("เขต") !== -1
          ? property.AmphurName
          : "เขต" + property.AmphurName;
    } else {
      location += property.AmphurName;
    }
    location += " ";
  }

  if (property.ProvinceName) {
    location += property.ProvinceName;
  }

  //  Property Name
  var propertyName;
  var title;

  if (property.VillageTH && property.VillageTH !== "-") {
    propertyName = property.VillageTH;
    if (propertyName.length > 46) {
      propertyName = propertyName.slice(0, 50) + "...";
    }
    title = "ดูเพิ่มเติม " + propertyName;
  } else {
    propertyName = `${getPropertyType(property)} ${property.ProvinceName}`;
    title = "ดูเพิ่มเติม";
  }

  //  Price
  let tag = "";
  let PromotionPrice = "";
  let Price = "";
  if (property.PromotionPrice) {
    tag = (
      <div className="special-badge">
        <p>ราคาพิเศษ</p>
      </div>
    );
    PromotionPrice = (
      <p className="spacial-price special-price">
        {addSpan(property.PromotionPrice, atBath)}
      </p>
    );
    Price = <p className="old-price">{addCommas(property.SellPrice, 0)} บาท</p>;
  } else if (property.AdjustPrice) {
    tag = (
      <div className="lower-badge">
        <p>ราคาลดลงกว่าเดิม</p>
      </div>
    );
    PromotionPrice = (
      <p className="spacial-price special-price c-black">
        {addSpan(property.AdjustPrice, atBath)}
      </p>
    );
    Price = <p className="old-price">{addCommas(property.SellPrice, 0)} บาท</p>;
  } else {
    PromotionPrice = (
      <p className="spacial-price special-price c-black">
        {addSpan(property.SellPrice, atBath)}
      </p>
    );
    Price = (
      <p className="old-price" style={{ opacity: "0" }}>
        -
      </p>
    );

    tag = (
      <div className="lower-badge" style={{ opacity: "0" }}>
        <p>-</p>
      </div>
    );
  }

  //area
  var areaHtml;
  var area = getArea(property);

  if (area !== null) {
    areaHtml = (
      <p>
        <i className="ic-npa ic-npa-icon-area"></i> <span>{area.value}</span>{" "}
        {area.unit}
      </p>
    );
  } else {
    areaHtml = (
      <p>
        <i className="ic-npa ic-npa-icon-area"></i>&nbsp;
      </p>
    );
  }

  //bed & bath
  var bedRoomHtml;
  if (showBedAndBath(property)) {
    var bed;
    var bath;
    if (property.Bedroom && property.Bedroom > 0) {
      if (isBedPTag) {
        bed = (
          <p>
            <i className="ic-npa ic-npa-icon-bedroom"></i>
            <span>{property.Bedroom}</span>
          </p>
        );
      } else {
        bed = (
          <span>
            <i className="ic-npa ic-npa-icon-bedroom"></i>
            <span>{property.Bedroom}</span>
          </span>
        );
      }
    }
    if (property.Bathroom && property.Bathroom > 0) {
      if (isBedPTag) {
        bath = (
          <p>
            <i className="ic-npa ic-npa-icon-bathroom"></i>
            <span>{property.Bathroom}</span>
          </p>
        );
      } else {
        bath = (
          <span>
            <i className="ic-npa ic-npa-icon-bathroom"></i>
            <span>{property.Bathroom}</span>
          </span>
        );
      }
    }
    if (bed && bath) {
      bedRoomHtml = [bed, <span className="pipe spacer"></span>, bath];
    } else if (bed || bath) {
      bedRoomHtml = [bed, bath];
    } else {
      bedRoomHtml = <p>&nbsp;</p>;
    }
  }

  //assetType
  var propertyTypeHtml;
  if (property.PropertyTypeName) {
    propertyTypeHtml = getPropertyType(property);
  } else {
    propertyTypeHtml = "&nbsp;";
  }

  var PropertyIDFormat = property.PropertyID
    ? `${property.PropertyID?.slice(0, 2)}-${property.PropertyID?.slice(
        2,
        4
      )}-${property.PropertyID?.slice(4)}`
    : "";

  var Logo =
    "/SiteCollectionDocuments/assets/PFS2022/theme/img/logo/" +
    property.SourceImageLogo;
  var IsPartner = checkIsPartner(property) ? Logo : false;

  return {
    propertyDetailURL,
    thumbnailURL,
    location,
    propertyName,
    tag,
    PromotionPrice,
    Price,
    areaHtml,
    bedRoomHtml,
    propertyTypeHtml,
    PropertyIDFormat,
    IsPartner,
    imgPCList,
  };
}

function addSpan(value, atBath = true) {
  if (atBath) {
    return (
      <>
        {addCommas(value, 0)} <span>บาท</span>
      </>
    );
  } else {
    return (
      <>
        {" "}
        <span>{addCommas(value, 0)}</span> บาท
      </>
    );
  }
}

export function checkIsPartner(data) {
  return data.SourceSaleType == "Partner";
  var propertyCode = data.PropertyID.slice(2, 4);
  switch (propertyCode) {
    case "10":
      return true;
    default:
      return false;
  }
}
